import React, { Component } from 'react';

import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';

import Canvas from '../Canvas';
import Drawer from './Drawer';
import FormInput from '../FormInput';

import * as BIBCONFIG from '../../constants/bibConfig';
import UserManager from '../../UserManager';

import './index.css';

const DEFAULT_NAME = 'Prénom Nom';
const DEFAULT_COMPANY_NAME = 'Nom du groupe';

// Level 1: no customization, only bib number
// Level 2: custom name
// Level 3: custom name and company name
class BibGen extends Component {
  constructor(props) {
    super(props);

    this._draw = this.draw.bind(this);
    this._onChange = this.onChange.bind(this);
    this._onDownload = this.onDownload.bind(this);
    this._getFileName = this.getFileName.bind(this);
    this._getCompanyNameInput = this.getCompanyNameInputRef.bind(this);
    this._getNameInput = this.getNameInputRef.bind(this);

    this.drawer = new Drawer();
    this.companyNameInputRef = React.createRef();
    this.nameInputRef = React.createRef();

    const userManager = UserManager.getInstance();

    this.state = {
      name: userManager.level > 1 ? DEFAULT_NAME : '',
      companyName: userManager.level > 2 ? DEFAULT_COMPANY_NAME : '',
      bibNumber: userManager.bibNumber,
      level: userManager.level,
      error: null,
    };
  }

  onChange(event) {
    this.setState({ [event.target.name]: event.target.value.trim() });
  }

  onError(inputRef) {
    this.setState({ error: 'Veuillez remplir les champs obligatoires' });
    inputRef.current.focus();
  }

  draw(ctx, canvas) {
    const { drawer } = this;
    const {
      name, companyName, bibNumber, level,
    } = this.state;
    this.ctx = ctx;
    this.canvas = canvas;

    drawer.drawBackground(ctx);
    drawer.drawHeader(ctx);
    drawer.drawFooter(ctx);

    if (level > 1) {
      drawer.drawName(ctx, name);
    }

    if (level > 2) {
      drawer.drawCompanyName(ctx, companyName);
    }
    drawer.drawBibNumber(ctx, bibNumber);
  }

  getFileName() {
    const { name, companyName, bibNumber } = this.state;

    return `${name} ${companyName} ${bibNumber} dossard.png`.trim();
  }

  getCompanyNameInputRef(ref) {
    this.companyNameInputRef = ref;
  }

  getNameInputRef(ref) {
    this.nameInputRef = ref;
  }

  onDownload() {
    const { level, companyName, name } = this.state;
    const image = this.canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream');

    if (level > 2 && BIBCONFIG.BIB_COMPANY_NAME_MANDATORY
      && (companyName.length === 0 || companyName === DEFAULT_COMPANY_NAME)) {
      this.onError(this.companyNameInputRef);

      return;
    }

    if (level > 1 && BIBCONFIG.BIB_NAME_MANDATORY
      && (name.length === 0 || name === DEFAULT_NAME)) {
      this.onError(this.nameInputRef);

      return;
    }

    this.downloadButton.setAttribute('href', image);
    this.setState({ error: null });
  }

  renderNameInput() {
    const { level } = this.state;

    if (level > 1) {
      return (
        <div>
          <FormInput
            onChange={this._onChange}
            getRef={this._getNameInput}
            name="name"
            placeholder="VOTRE PSEUDO"
            label="VOTRE PSEUDO"
          />
        </div>
      );
    }

    return (<div />);
  }

  renderCompanyNameInput() {
    const { level } = this.state;

    if (level > 2) {
      return (
        <div className="mb-3">
          <FormInput
            onChange={this._onChange}
            getRef={this._getCompanyNameInput}
            name="companyName"
            placeholder="NOM DU GROUPE"
            label="NOM DU GROUPE"
          />
        </div>
      );
    }

    return (<div />);
  }

  render() {
    const {
      name, companyName, bibNumber, error,
    } = this.state;

    return (
      <div className="bib-gen mt-4">
        <Container>
          <div>
            {this.renderCompanyNameInput()}
            {this.renderNameInput()}
          </div>

          <div className="mt-5">
            <Canvas
              className="w-100"
              draw={this._draw}
              download={this._download}
              height={BIBCONFIG.HEIGHT}
              width={BIBCONFIG.WIDTH}
              name={name}
              companyName={companyName}
              bibNumber={bibNumber}
            />
          </div>

          <div className="text-center mt-3">
            <a download={this._getFileName()} ref={(c) => (this.downloadButton = c)}>
              <Button className="mt-3 mb-3 green-button download-button" onClick={this._onDownload}>
                Télécharger l'image
              </Button>
            </a>

            <div className="errorMessage">
              {error}
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default BibGen;
